import PageTitle from '@/components/PageTitle';
import { Facebook, Globe, Linkedin, Mail, Twitter, X } from 'lucide-react';
import React, { Component } from 'react';
import JoinTeamModal from '@/components/JoinTeamModal';

function Our_Team() {
	return (
		<main className="min-h-screen bg-[#f8f6f2]">
			<PageTitle title="Our Team" bg="assets/img/WhatsApp-Image-2026-03-23-at-4.08.32-PM-3.jpeg"/>
			<About_3 />
			<CommunityPartners />
			<JoinTeamModal />
		</main>
	)
}
export default Our_Team


const directors = [
	{ name: 'LATANGELA ROGERS, M.A.', role: 'FOUNDER, PRESIDENT' },
	{ name: 'DR. JOSEPH NUERTEY M.D.', role: 'VICE PRESIDENT' },
	{ name: 'THEODORE OWUSU, MISSIONS & TOURISM', role: 'SECRETARY' },
	{ name: 'AMISHA ASKEW, LICENSED VOCATIONAL NURSE', role: 'TREASURER' },
	{ name: 'VACANT', role: 'EXECUTIVE BOARD MEMBER' },
	{ name: 'MERCEDES MABUSE, EDUCATOR, B.A.', role: 'EXECUTIVE BOARD MEMBER' },
];

export const About_3: React.FC = () => {
	return (
		<section className="relative overflow-hidden px-4 py-16 sm:py-20 md:px-8 md:py-24">
			<div className="relative mx-auto max-w-7xl rounded-[2rem] border border-primary/10 bg-white/70 p-5 shadow-xl shadow-primary/5 backdrop-blur-sm md:p-10">
				<div className="absolute w-full h-full bg-white/10 rotate-12 left-1/2 -top-52 -z-10" />
				<div className="absolute w-full h-full bg-white/5 rotate-12 left-1/2 -top-24 -z-10" />

				<p className="relative z-10 mb-4 text-center text-sm font-semibold uppercase tracking-[0.2em] text-primary">People behind the purpose</p>
				<h2 className="relative z-10 mb-12 text-center font-heading text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
					Board of Directors
				</h2>

				<div className="relative z-10 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
					{directors.map((director, index) => (
						<div
							key={index}
							className="group rounded-3xl border border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/25 hover:shadow-xl"
						>
							<div className='flex w-full h-full rounded-3xl overflow-hidden'>
								{/* <div className="w-[50%] h-full bg-gradient-to-br from-rose-600 to-rose-600 flex items-center justify-center text-white text-2xl font-bold shadow-lg">
									{director.name.charAt(0)}
								</div> */}
								<div className="flex w-full flex-col items-center justify-center space-y-4 p-5 py-7 text-center md:p-7 md:py-9">
									{director.name !== 'VACANT' && (
										<h3 className="font-bold text-base md:text-lg text-gray-900 leading-tight">
											{director.name}
										</h3>
									)}

									{director.name !== 'VACANT' && (
										<div className="h-0.5 w-12 bg-secondary" />
									)}

									<p className="text-sm md:text-base uppercase tracking-wider text-gray-600 font-medium">
										{director.role}
									</p>

									{director.name === 'VACANT' && (
										<p className="text-sm md:text-base text-gray-700">VACANT</p>
									)}

									{director.name === 'VACANT' && (
										<p className="text-sm md:text-base text-gray-700">
											We are currently seeking a qualified individual to fill this position. If you are interested in joining our board, please contact us.
										</p>
									)}

									{director.name !== 'VACANT' && (
										<div className="flex gap-4 text-[28px] text-[tomato]">
											<Facebook className="fab fa-facebook cursor-pointer hover:scale-110 transition" />
											<Twitter className="fab fa-twitter cursor-pointer hover:scale-110 transition" />
											<Globe className="fab fa-google-plus cursor-pointer hover:scale-110 transition" />
											<Linkedin className="fab fa-linkedin cursor-pointer hover:scale-110 transition" />
										</div>
									)}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};


const partners = [
	{ name: 'JP Morgan Chase', img: 'assets/img/Chase_logo.png' },
	{ name: 'Encompass Health', img: 'assets/img/Encompass_Health_logo.png' },
	{ name: 'Accra Psychiatric Hospital', img: 'assets/img/Accra_Psych_Hospital_logo.jpg' },
	{ name: 'ReMax', img: 'assets/img/ReMax_png_logo.jpg' },
	// { name: 'Cheryl Williamson', img: 'assets/img/Cheryl_Williams_logo.png' },
	{ name: 'Shama District Assembly', img: 'assets/img/Shama_District_Logo.jpg' },
	{ name: 'Ghana Health Services', img: 'assets/img/Ghana_Health_Services_Logo.jpg' },
	{ name: 'Volta River Authority', img: 'assets/img/VRA.png' },
	{ name: 'Starbucks', img: 'assets/img/Starbucks.jpg' },
	{ name: 'Costco', img: 'assets/img/Costco.png' },
	{ name: 'Nothing Bundt Cakes', img: 'assets/img/Nothing_bunt_cakes.png' },
];

export const CommunityPartners: React.FC<{ justIcons?: boolean }> = ({ justIcons = false }) => {
	return (
		<section className="relative overflow-hidden px-4 pb-16 sm:pb-20 md:px-8 md:pb-24">
			<div className={`relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] border border-primary/10 bg-white/75 shadow-xl shadow-primary/5 backdrop-blur-sm
				${justIcons ? 'p-4 md:p-6' : 'px-6 py-12 md:px-12 md:py-16'}`}>
				{/* <div className="absolute w-full h-[200%] bg-black/5 rotate-12 left-1/2 -top-52 -z-10" />
				<div className="absolute w-full h-[200%] bg-black/5 rotate-12 left-1/2 -top-24 -z-10" /> */}

				<div className="relative z-10">
					{!justIcons && (
						<h2 className="mb-12 text-center font-heading text-3xl font-bold text-foreground md:mb-16 md:text-4xl lg:text-5xl">
							Our Community Partners & Sponsors
						</h2>
					)}

					<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-10 mb-12 md:mb-16">
						{partners.map((partner, index) => (
							<div
								key={index}
								className="group flex flex-col items-center justify-center space-y-3 text-center transition-transform duration-300 hover:-translate-y-1"
							>
								<div className="flex h-20 w-full items-center justify-center rounded-3xl border border-border bg-white p-2 shadow-sm transition-shadow duration-300 group-hover:shadow-lg md:h-24">
									<img
										src={partner.img}
										alt={partner.name}
										className="max-h-full max-w-full object-contain"
									/>
								</div>
								<p className="text-xs md:text-sm tracking-wide font-medium text-gray-700">
									{partner.name}
								</p>
							</div>
						))}
					</div>

					<div className="rounded-3xl border border-primary/10 bg-primary/5 p-6 md:p-8">
						<p className="text-center tracking-wide leading-relaxed text-base md:text-lg text-gray-700 max-w-4xl mx-auto">
							We are not able to do the work that we do to rebuild the communities we serve without our
							community partners and sponsors. If you are interested in becoming one of our community
							partners or sponsors contact us at:
						</p>

						<div className="flex justify-center mt-6">
							<a
								href="mailto:info@roseofjericho-cd.org"
								className="inline-flex items-center gap-2 px-6 py-3 bg-rose-600 text-white rounded-full hover:bg-rose-700 transition-all duration-300 hover:scale-105 shadow-lg font-medium"
							>
								<Mail className="w-5 h-5" />
								info@roseofjericho-cd.org
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
